import * as React from 'react';

import { FournisseurApi } from '@europrocurement/l2d-domain';
import PublishersRejectCodesList from '../../../../../../Achats/views/lists/PublishersRejectCodesList';

export type PurchaseInvoiceSettingsProps = {
    publisher: FournisseurApi;
};

const PurchaseInvoiceSettings: React.FunctionComponent<PurchaseInvoiceSettingsProps> = function ({
    publisher,
}) {
    return <PublishersRejectCodesList publisher={publisher} />;
};

export default PurchaseInvoiceSettings;
